import React from "react";
import { connect } from "react-redux";
import { updateImage } from "../actions/panel";
import ReactTooltip from "react-tooltip";
import { FormattedMessage } from "react-intl";

const mapDispatchToProps = {
  updateImage
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  image: {
    ...ownProps.image,
    update: dispatchProps.updateImage.bind(
      null,
      ownProps.panelId,
      ownProps.frameId,
      ownProps.frameListId,
      ownProps.image.id
    )
  }
});

const ImageSelector = connect(
  null,
  mapDispatchToProps,
  mergeProps
)(props => {
  const attrs = {
    id: `image-selector_${props.panelId}_${props.frameId}_${props.image.id}`,
    onClick: e => {
      e.stopPropagation(); // prevent the event from bubbling up to the frame selector
      props.image.update();
    },
    className: "image-selector selector"
  };
  const tooltipId = `${attrs.id}_tooltip`;

  if (props.image.isActive) {
    attrs.className += " selected";
  }
  if (props.image.isCurrent) {
    attrs.className += " current";
  }

  return (
    <div {...attrs} data-tip data-for={tooltipId}>
      <ReactTooltip id={tooltipId} place="top" effect="solid">
        <FormattedMessage
          id="panel_selector_tooltip_issued"
          defaultMessage="Issued"
        />
        : {props.image.label}
      </ReactTooltip>
      &nbsp;
    </div>
  );
});

const ImageSelectorGroup = props => {
  return (
    <div className="image-selector-group">
      {props.image.list.map(image => (
        <ImageSelector
          key={image.id}
          panelId={props.panelId}
          frameId={props.frameId}
          frameListId={props.frameListId}
          image={{
            id: image.id,
            label: image.created,
            isActive: props.image.activeId === image.id,
            isCurrent: props.image.currentId === image.id
          }}
        />
      ))}
    </div>
  );
};

export default ImageSelectorGroup;
